import {
  Employee,
  EmployeePage,
  Merchant,
  Store,
  Threshold,
} from '@bofrak-backend/shared';
import { atom } from 'recoil';
import { localPersistEffect } from './atom-effects';
import {
  displayCurrencyEffect,
  storeDisplayCurrencyEffect,
} from '../../utils/display-currency';
import { startOfDay, endOfDay } from 'date-fns';

export const dateRangeAtom = atom<{
  start: Date | null;
  end: Date | null;
}>({
  key: 'dateRangeAtom',
  default: {
    start: startOfDay(new Date()),
    end: endOfDay(new Date()),
  },
  // effects_UNSTABLE: [localPersistEffect],
});

export const tokenAtom = atom({
  key: 'user-token',
  default: '',
  effects_UNSTABLE: [localPersistEffect],
});

export const merchantAtom = atom<Merchant | null>({
  key: 'merchantAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect, displayCurrencyEffect],
});

export const adminAtom = atom<Employee | null>({
  key: 'adminAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect],
});

export const usersAtom = atom<EmployeePage | null>({
  key: 'usersAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect],
});

export const selectedUserAtom = atom<Employee | null>({
  key: 'selectedUserAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect],
});

export const thresholdAtom = atom<Threshold | null>({
  key: 'thresholdAtom',
  default: null,
});

export const searchQueryAtom = atom<string>({
  key: 'searchQueryAtom',
  default: '',
});

export const accessTokenAtom = atom<string | undefined>({
  key: 'accessTokenAtom',
  default: '',
  effects_UNSTABLE: [localPersistEffect],
});

export const storeAtom = atom<Store | null>({
  key: 'storeAtom',
  default: null,
  effects_UNSTABLE: [localPersistEffect, storeDisplayCurrencyEffect],
});

export const storeListAtom = atom<Store[]>({
  key: 'storeListAtom',
  default: [],
  effects_UNSTABLE: [localPersistEffect],
});
